"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeOptimizerUser = exports.createSomeDirectorUser = void 0;
const User_1 = require("../entity/User");
const createSomeDirectorUser = ({ id = '73', name = 'Victor Hugot', email = 'victorhugot@example.com', profileImageUrl = 'https://loremflickr.com/g/256/256/girl', } = {}) => new User_1.DirectorUser({ id, name, email, profileImageUrl });
exports.createSomeDirectorUser = createSomeDirectorUser;
const createSomeOptimizerUser = ({ id = '79', name = 'Victor Hugot', email = 'victorhugot@example.com', profileImageUrl = 'https://loremflickr.com/g/256/256/boy', } = {}) => new User_1.OptimizerUser({ id, name, email, profileImageUrl });
exports.createSomeOptimizerUser = createSomeOptimizerUser;
